import { VuexModule, getModule, Module, Action, Mutation } from 'vuex-module-decorators'
import store from '@/store'
import { Message } from 'element-ui'

// 关于这个vux文件的信息配置
@Module({
    name: 'SubMenuRight',
    namespaced: true, // 命名空间
    store, // store
    dynamic: true, //动态创建Vuex模块，不用手动注册
})
export default class SubMenuRight extends VuexModule {
    // 未配置人员------no-setting
    noSetting = {
        checkedNumber: 0, // 选中的人数
        dialogShow: false // 弹框是否显示
    }
    // 数据转移------data-share
    dataShare = {
        dialogDataShow: false, // 弹框是否显示
        addDialog: false
    }
    
    // CRM消息 ------ 通知
    messageNotice = {
        dialogShow: false,
    }

    // CRM消息 ------ 审批
    messageApproval = {
        checkNumber: 0,
        checkRow: []
    }
    @Mutation
    setMessageApproval(data: any) {
        this.messageApproval.checkRow = data
        this.messageApproval.checkNumber = data.length
    }
    @Action
    batchMessageApproval() {  // 批量通过审批
        Message.success('批量通过审批')
        console.log(this.messageApproval.checkRow);
    }

    // 市场运营 ------ 市场线索
    marketClues = {
        issueDialogVisible: false, // 下发弹框
        MarkInvalidDialogVisible: false, // 标为无效
        editUpPersonDialogVisible: false, // 修改跟进人
        editSourceDialogVisible: false, // 修改来源
        editDutyDialogVisible: false, // 修改负责人
        checkedNumber: 0, // 此时选中的数据数量
    }

}
export const SubMenuRightModule = getModule(SubMenuRight)
